import React, { useEffect, useState } from "react";
import AccountHandler from "../../../services/api/accountHandler";
import {
  Flex,
  Segment,
  Button,
  Provider,
} from "@fluentui/react-northstar";
import ImageTitleContainer from "../ImageTitleContainer";
import AboutYouImage from "../../../assets/images/undraw_profile_6l1l.svg";
import Constants from "../../../constants/text-constants";
import TellUsABoutYouForm from "../../molecules/Forms/TellUsAboutYouForm";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";

const TellUsAboutYou = observer((props) => {
  const [accountProfile, setAccountProfile] = useState({});
  const { tellAboutYouOnboardComplete } = props;

  useEffect(() => {
    AccountHandler
      .getAccountProfile()
      .then((resp) => {
        setAccountProfile(resp);
      })
      .catch((e) => {
        console.warn("getAccountProfile failed", e);
      });
  }, []);

  const onSave = ({firstName}) => {
    if (tellAboutYouOnboardComplete) {
      tellAboutYouOnboardComplete({ firstName, onboardingComplete: true });
    }
  };

  const onSkip = () => {
    if (tellAboutYouOnboardComplete) {
      tellAboutYouOnboardComplete({ onboardingComplete: true });
    }
  };

  const skipButton = (
    <Button
      className="skip-button"
      text
      size="small"
      data-testid="tellUsABoutYouSkipButton"
      onClick={onSkip}
      content={Constants.SKIP}
    />
  );

  const bgClass = "page full-screen";
  const bgClassSegment = "tell-us-about-you-container segment";

  return (
    <Provider.Consumer
      render={(theme) => (
        <Flex
          className={
            theme.siteVariables.themeString === "default"
              ? bgClass + " bg-onboarding default"
              : bgClass
          }
          data-testid="tellUsAboutYou"
          column
        >
          <Segment
            className={
              theme.siteVariables.themeString === "dark"
                ? bgClassSegment + " dark"
                : bgClassSegment
            }
            data-testid="tellUsAboutYouSegment"
          >
            <Flex className="tell-us-about-you-container-flex">
              <ImageTitleContainer
                image={AboutYouImage}
                title={Constants.TELL_US_ABOUT_YOU_TITLE}
                subTitle={Constants.TELL_US_ABOUT_YOU_SUBTITLE}
                testId="tellUsAboutYouContainer"
              >
                <Flex className="tell-us-about-you-container-flex-form">
                  <TellUsABoutYouForm
                    firstName={accountProfile.firstname ?? ''}
                    lastName={accountProfile.surname ?? ''}
                    emailAddress={accountProfile.email ?? ''}
                    tellAboutYouOnboardComplete={onSave}
                  />
                </Flex>
              </ImageTitleContainer>
            </Flex>
            {skipButton}
          </Segment>
        </Flex>
      )}
    ></Provider.Consumer>
  );
});

TellUsAboutYou.propTypes = {
  tellAboutYouOnboardComplete: PropTypes.func,
};

export default TellUsAboutYou;
